export var FormMode;
(function (FormMode) {
    FormMode["Login"] = "login";
    FormMode["Register"] = "signup";
})(FormMode || (FormMode = {}));
export var LoginBy;
(function (LoginBy) {
    LoginBy["Email"] = "email";
    LoginBy["Wallet"] = "wallet";
    LoginBy["EmailAndWallet"] = "emailAndWallet";
    LoginBy["Google"] = "google";
})(LoginBy || (LoginBy = {}));
export var CloseBehavior;
(function (CloseBehavior) {
    CloseBehavior["Normal"] = "normal";
    CloseBehavior["Disabled"] = "disabled";
    CloseBehavior["Redirect"] = "redirect";
})(CloseBehavior || (CloseBehavior = {}));
